import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";
// import { IoIosArrowForward } from "react-icons/io";

const Blog1 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b3a2e345-510a-4030-444c-8dbccf803f00/public" //Init_Blog1.webp
                alt="Img"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <p
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                Tech Trends 2024: <br />
                <span className="font-semibold">What's Hot in IT</span>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            Dive into the future with INIT Technology! As we step into 2024,
            let’s explore the cutting-edge tech trends shaping our digital
            landscape.
          </p>

          <p>Here’s a sneak peek:</p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p>1. AI-Powered Innovations</p>
            <p>2. Virtual Frontiers</p>
            <p>3. ⁠Sustainability in Tech</p>
            <p>4. ⁠Next-Gen Interfaces</p>
          </div>

          <p>
            <span className="font-semibold">1. AI-Powered Innovations: </span>
            Witness the transformative power of smart automation and
            personalized experiences, redefining the very fabric of industries.
          </p>

          <p>
            <span className="font-semibold">2. Virtual Frontiers:</span>
            Immerse yourself in the boundless possibilities of the Metaverse,
            where connectivity and experiences are being reinvented in ways
            unimaginable.
          </p>

          <p>
            <span className="font-semibold">3. Sustainability in Tech: </span>
            Join us in curating eco-friendly solutions, as we strive to create a
            world where technology and sustainability coexist.
          </p>

          <p>
            <span className="font-semibold">4. Next-Gen Interfaces:</span>
            Explore the future of user interfaces and experiences, where
            innovation seamlessly merges with intuitive interaction, opening up
            new dimensions of user experience.
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>September 1, 2024 ∙ 3 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog1;
